// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pycnometer-panel {
  display: flex;
  flex-direction: column;
  gap: 0.85rem;
}

.pycnometer-change-link {
  display: inline-flex;
  align-items: center;
  margin-top: 0.45rem;
  font-size: 0.85rem;
  color: #0d6efd;
  text-decoration: underline;
  cursor: pointer;
}

.pycnometer-profile-picker {
  border: 1px solid #e3e8ef;
  border-radius: 4px;
  padding: 0.65rem;
  background: #ffffff;
}

.pycnometer-profile-list {
  display: flex;
  flex-direction: column;
  gap: 0.45rem;
}

.pycnometer-profile-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 0.75rem;
  padding: 0.35rem 0;
  border-bottom: 1px dashed #d7e0ea;
}

.pycnometer-profile-item:last-child {
  border-bottom: 0;
  padding-bottom: 0;
}

.pycnometer-runs-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 0.75rem;
}

.pycnometer-run-card {
  border: 1px solid #d9e2ec;
  border-radius: 4px;
  padding: 0.6rem;
  background: #ffffff;
  display: flex;
  flex-direction: column;
  gap: 0.45rem;
}

.pycnometer-run-title {
  font-weight: 700;
  color: #334155;
  font-size: 0.82rem;
  text-transform: uppercase;
  letter-spacing: 0.02em;
}

.test-detail-section {
  border: 1px solid #e3e8ef;
  border-radius: 4px;
  padding: 0.65rem;
  background: #ffffff;
}

.test-detail-title {
  margin: 0 0 0.55rem;
  font-size: 0.85rem;
  font-weight: 700;
  color: #3f4954;
  text-transform: uppercase;
  letter-spacing: 0.02em;
}

.test-detail-fields {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 0.65rem 1rem;
}

.test-detail-field {
  display: flex;
  flex-direction: column;
  gap: 0.3rem;
}

.test-detail-label {
  margin: 0;
  font-size: 0.85rem;
  color: #555;
  font-weight: 600;
}

.test-row-error {
  color: #b42318;
  font-size: 0.8rem;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/job-details/job-request-overview/test-details/job-request-test-pycnometer-detail.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;AACF;;AAEA;EACE,oBAAA;EACA,mBAAA;EACA,mBAAA;EACA,kBAAA;EACA,cAAA;EACA,0BAAA;EACA,eAAA;AACF;;AAEA;EACE,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;AACF;;AAEA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;EACA,iCAAA;AACF;;AAEA;EACE,gBAAA;EACA,iBAAA;AACF;;AAEA;EACE,aAAA;EACA,2DAAA;EACA,YAAA;AACF;;AAEA;EACE,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;AACF;;AAEA;EACE,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,yBAAA;EACA,sBAAA;AACF;;AAEA;EACE,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AACF;;AAEA;EACE,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,yBAAA;EACA,sBAAA;AACF;;AAEA;EACE,aAAA;EACA,2DAAA;EACA,iBAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,WAAA;AACF;;AAEA;EACE,SAAA;EACA,kBAAA;EACA,WAAA;EACA,gBAAA;AACF;;AAEA;EACE,cAAA;EACA,iBAAA;AACF","sourcesContent":[".pycnometer-panel {\n  display: flex;\n  flex-direction: column;\n  gap: 0.85rem;\n}\n\n.pycnometer-change-link {\n  display: inline-flex;\n  align-items: center;\n  margin-top: 0.45rem;\n  font-size: 0.85rem;\n  color: #0d6efd;\n  text-decoration: underline;\n  cursor: pointer;\n}\n\n.pycnometer-profile-picker {\n  border: 1px solid #e3e8ef;\n  border-radius: 4px;\n  padding: 0.65rem;\n  background: #ffffff;\n}\n\n.pycnometer-profile-list {\n  display: flex;\n  flex-direction: column;\n  gap: 0.45rem;\n}\n\n.pycnometer-profile-item {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 0.75rem;\n  padding: 0.35rem 0;\n  border-bottom: 1px dashed #d7e0ea;\n}\n\n.pycnometer-profile-item:last-child {\n  border-bottom: 0;\n  padding-bottom: 0;\n}\n\n.pycnometer-runs-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));\n  gap: 0.75rem;\n}\n\n.pycnometer-run-card {\n  border: 1px solid #d9e2ec;\n  border-radius: 4px;\n  padding: 0.6rem;\n  background: #ffffff;\n  display: flex;\n  flex-direction: column;\n  gap: 0.45rem;\n}\n\n.pycnometer-run-title {\n  font-weight: 700;\n  color: #334155;\n  font-size: 0.82rem;\n  text-transform: uppercase;\n  letter-spacing: 0.02em;\n}\n\n.test-detail-section {\n  border: 1px solid #e3e8ef;\n  border-radius: 4px;\n  padding: 0.65rem;\n  background: #ffffff;\n}\n\n.test-detail-title {\n  margin: 0 0 0.55rem;\n  font-size: 0.85rem;\n  font-weight: 700;\n  color: #3f4954;\n  text-transform: uppercase;\n  letter-spacing: 0.02em;\n}\n\n.test-detail-fields {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));\n  gap: 0.65rem 1rem;\n}\n\n.test-detail-field {\n  display: flex;\n  flex-direction: column;\n  gap: 0.3rem;\n}\n\n.test-detail-label {\n  margin: 0;\n  font-size: 0.85rem;\n  color: #555;\n  font-weight: 600;\n}\n\n.test-row-error {\n  color: #b42318;\n  font-size: 0.8rem;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
